import { useContext, useEffect, useState } from "react";
import CreateTaskHeader from "../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader";
import { useApi } from "../Dashboard/CustomHooks/useApi";
import LayoutWrapper from "../../components/utility/layoutWrapper";
import { AppContext } from "../../context/ContextProvider";
import LoadData from "../Dashboard/CustomComponents/LoadData";
import { Avatar, Button, Input, List, Tag, Typography } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import "./ObjectRoles.style.css";
import Scrollbars from "react-custom-scrollbars-2";
import CreateTaskFooter from "../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskFooter/CreateTaskFooter";
import { useDeploymentFeatures } from "../Dashboard/CustomHooks/useDeploymentFeatures";
import { CustomList } from "../Dashboard/CustomComponents/CustomList.style";
import useDebounce from "../Dashboard/CustomHooks/useDebounce";
import { PlusOutlined } from "@ant-design/icons";
const colorObj = ["#1D61A0", "#2B2F8F", "#176A76", "#761717", "#AD0C50", "#AF3232", "#CCE1F1"];

export default function AssignRole({ data }) {

    const { setOpenRightDrawer, setRefreshBoardList } = useContext(AppContext);

    const { toggleAlert } = useDeploymentFeatures();

    const [search, setSearch] = useState("");

    const [list, setList] = useState(data?.assignUsers ? data?.assignUsers : []);

    // getting users list

    const { data: userData, setData: setUserData, loading: userLoading, error: usersError } = useApi({
        url: "/api/users/users_list?verified=true&exclude_inactive=true",
        method: "GET",
        initialData: {},
        manual: false,
        isPaginate: false
    });

    // for sending put/post request

    const { sendRequest } = useApi({
        manual: true,
        isPaginate: false,
    });

    const handleAdd = (item) => {
        setList(list => ([...list, item.id]));
    }

    const handleClose = (item) => {
        setList(list => list.filter((val) => val !== item.id));
    }

    const handleSearch = useDebounce((e) => {
        setSearch(e.target.value);
    }, 200, []);

    const handleSave = async () => {
        try {
            const payload = {
                users: list
            }
            await sendRequest({
                url: `/api/users/admin/roles/users/${data?.roleId}/`,
                method: 'PUT',
                data: { ...payload },
                showError: true,
                showSuccess: true,
            });
            setRefreshBoardList(true);
            setOpenRightDrawer({
                drawerType: null,
                drawerProps: {
                    data: null
                }
            });
        }
        catch (err) {
            console.log("Error found..", err);
            // toggleAlert("error", "Error", "Something went wrong.");
        }
    }

    const onCancel = () => {
        setOpenRightDrawer({
            drawerType: null,
            drawerProps: {
                data: null
            }
        });
    }

    const assignedUsers = userData.users?.filter((val) => !search ? list.includes(val.id) : (val.first_name + " " + val.last_name).toLowerCase().includes(search.toLowerCase()) && list.includes(val.id));
    const unAssignedUsers = userData.users?.filter((val) => !search ? !list.includes(val.id) : (val.first_name + " " + val.last_name).toLowerCase().includes(search.toLowerCase()) && !list.includes(val.id));
    return (
        <>
            <CreateTaskHeader
                buttonContent={"Edit Role Members"}
                onCancel={onCancel}
            />
            <LayoutWrapper className="assign-role-wrapper">
                <LoadData loading={(data ? userLoading : false)} data={data}>
                    <Input className="search-input" prefix={<SearchOutlined />} placeholder="Search..." onChange={handleSearch} />
                    <Scrollbars style={{ height: "100%" }}>
                        <CustomList
                            header={`Assigned Members`}
                            className="assigned-members-list"
                            dataSource={assignedUsers}
                            itemLayout="horizontal"
                            renderItem={(item, idx) => {
                                const showRoles = item.roles?.slice(0, 2).map((val) => (<Tag key={val}>{val}</Tag>));
                                console.log("Getting item roles...", item.roles);
                                if (item.roles?.length > 2) {
                                    showRoles.push(<Tag className="tag-extra" key={"extra"} title={item.roles.slice(2).join(", ")}>{("+" + (item.roles.length - 2))}</Tag>);
                                }
                                console.log("Show roles...", showRoles);
                                return (<List.Item actions={[
                                    ...showRoles,
                                    <Button type="link" variant="link" title={showRoles.length === 1 ? "Cannot remove last role" : "Remove"} disabled={showRoles.length === 1}>
                                        <CloseOutlined onClick={() => handleClose(item)} style={{ color: "#b41313" }} />
                                    </Button>
                                ]}>
                                    <List.Item.Meta
                                        avatar={<Avatar src={<Typography.Text style={{ color: "white" }}>{item.first_name[0]}</Typography.Text>} style={{ marginRight: "8px", background: colorObj[idx % colorObj.length] }} />}
                                        title={(<>{item.first_name + " " + item.last_name} <Typography.Text style={{ color: "#6486ee" }}>{!item.roles.includes(data?.roleName) ? "(Added)" : ""}</Typography.Text></>)}
                                        description={item.email}
                                    />
                                </List.Item>);
                            }}
                        />
                        <CustomList
                            header={`Available Users`}
                            dataSource={unAssignedUsers}
                            className="available-users-list"
                            itemLayout="horizontal"
                            renderItem={(item, idx) => {
                                const showRoles = item.roles?.slice(0, 2).map((val) => (<Tag key={val}>{val}</Tag>));
                                if (item.roles?.length > 2) {
                                    showRoles.push(<Tag className="tag-extra" key={"extra"} title={item.roles.slice(2).join(", ")}>{("+" + (item.roles.length - 2))}</Tag>);
                                }
                                return <List.Item actions={[
                                    ...showRoles,
                                    <Button className="add-btn" onClick={() => handleAdd(item)}><PlusOutlined style={{ marginRight: "-4px" }} />Add</Button>
                                ]}>
                                    <List.Item.Meta
                                        avatar={<Avatar src={<Typography.Text style={{ color: "white" }}>{item.first_name[0]}</Typography.Text>} style={{ marginRight: "8px", background: colorObj[idx % colorObj.length] }} />}
                                        title={(<>{item.first_name + " " + item.last_name} {/*<Typography.Text style={{color: "#6486ee"}}>{item.roles.includes(data?.roleName) ? "(Added)" : ""}</Typography.Text>*/}</>)}
                                        description={item.email}
                                    />
                                </List.Item>
                            }}
                        />
                    </Scrollbars>
                </LoadData>
            </LayoutWrapper>
            <CreateTaskFooter buttonContent={"Edit Role Members"} givenButtonFunction2={onCancel} givenButtonFunction1={handleSave} disabled={userLoading} />
        </>
    );
}